import React from "react";
import About from "../AboutSection/About/About";
import Contact from "../ContactSection/Contact/Contact";
import Education from "../EducationSection/Education/Education";
import Experience from "../ExperienceSection/Experience/Experience";
import Footer from "../Footer/Footer";
import Home from "../Home/Home";
import Navbar from "../Navbar/Navbar";
import Portfolio from "../PortfolioSection/Portfolio/Portfolio";
import Quote from "../Quote/Quote";
import ViewProfile from "../ViewProfile/ViewProfile";
import './Main.scss';

const Main = () => {

    return (
        <>
            <Navbar />

            <Home />
            <About />
            <ViewProfile />
            <Experience />
            <Education />
            <Quote />
            <Portfolio />
            <Contact />
            <Footer link="#home" />
        </>
    );
}

export default Main;
